module.exports = __webpack_public_path__ + "static/media/fvs_valve1_61.385c04ba.jpg";